export const getTableTranslation = () => {
    return ac_table_i18n;
};
export const getTableConfig = () => {
    return ac_table;
};
